const TRANZILA = 'tranzila'
const BM_SYSTEMS = 'bmsystems'

const list = [TRANZILA, BM_SYSTEMS]
const providerName = {TRANZILA, BM_SYSTEMS, list}
export default providerName
